import { RxDashboard } from "react-icons/rx";
import { BiSolidBuilding } from "react-icons/bi";
import { RiUserVoiceLine } from "react-icons/ri";
import { HiOutlineOfficeBuilding } from "react-icons/hi";
import { MdOutlineCategory } from "react-icons/md";
import { FaRegUserCircle } from "react-icons/fa";
import { FormattedMessage } from "react-intl";

export const links = [
    // {
    //     title: <FormattedMessage id="dashboard" defaultMessage={"Dashboard"} />,
    //     Icon: RxDashboard,
    //     links: [
    //         {
    //             title: <FormattedMessage id="Tickets" defaultMessage={"Tickets"} />,
    //             Icon: FiUser,
    //             to: "/tickets",
    //         }
    //     ]
    // },
    {
        title: <FormattedMessage id="dashboard" defaultMessage={"Dashboard"} />,
        Icon: RxDashboard,
        to: "/",
        heading:<FormattedMessage id="main" defaultMessage={"Main"} />
    },
    {
        title: <FormattedMessage id="agencies" defaultMessage={"Agencies"} />,
        Icon: HiOutlineOfficeBuilding,
        to: "/agencies",
    },
    {
        title: <FormattedMessage id="influencers" defaultMessage={"Influencers"} />,
        Icon: RiUserVoiceLine,
        to: "/influencers",
    },
    // {
    //     title: "Categories",
    //     Icon: MdOutlineCategory,
    //     to: "/categories",
    // },
    {
        title: <FormattedMessage id="profile" defaultMessage={"Profile"} />,
        Icon: FaRegUserCircle,
        to: "/profile",
        heading:<FormattedMessage id="settings" defaultMessage={"Settings"} />
    },
    
]